<app-cfet-nav-header *ngIf="!isUTFFlow"></app-cfet-nav-header>
<app-utf-nav-header *ngIf="isUTFFlow"></app-utf-nav-header>
<app-load-spinner></app-load-spinner>
<router-outlet></router-outlet>
<router-outlet name ="utf"></router-outlet>
<app-cfet-nav-footer></app-cfet-nav-footer>